import { api, useCurrentUser } from '@cma/app'
import {
  CreatePlatformClientFolderMutation,
  CreatePlatformClientFolderMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useCreatePlatformClientFolder() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    CreatePlatformClientFolderMutation,
    Error,
    CreatePlatformClientFolderMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation CreatePlatformClientFolder($input: FolderInput!) {
          createPlatformClientFolder(input: $input) {
            errors
            folder {
              createdAt
              id
              name
              ownerId
              ownerType
              updatedAt
              customPages {
                accountId
                createdAt
                displayName
                folderId
                id
                platformClientContentContentType
                platformClientContentUrl
                thumbnail
                updatedAt
              }
            }
          }
        }
      `
      return api<
        CreatePlatformClientFolderMutation,
        CreatePlatformClientFolderMutationVariables
      >({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: currentUser?.account?.id || '' }
        ])
      }
    }
  )
}
